import api from './api';

export const getPosts = async () => {
    const response = await api.get('/api/community/posts');
    return response.data;
};

export const createPost = async (data) => {
    const response = await api.post('/api/community/posts', data);
    return response.data;
};

export const editPost = async (postId, data) => {
    const response = await api.put(`/api/community/posts/${postId}`, data);
    return response.data;
};

export const deletePost = async (postId) => {
    const response = await api.delete(`/api/community/posts/${postId}`);
    return response.data;
};

export const likePost = async (postId) => {
    const response = await api.post(`/api/community/posts/${postId}/like`);
    return response.data;
};

export const commentOnPost = async (postId, data) => {
    const response = await api.post(`/api/community/posts/${postId}/comment`, data);
    return response.data;
};

export const deleteComment = async (postId, commentId) => {
    const response = await api.delete(`/api/community/posts/${postId}/comment/${commentId}`);
    return response.data;
};

export const replyToComment = async (postId, commentId, data) => {
    const response = await api.post(`/api/community/posts/${postId}/comment/${commentId}/reply`, data);
    return response.data;
};

export const deleteReply = async (postId, commentId, replyId) => {
    const response = await api.delete(`/api/community/posts/${postId}/comment/${commentId}/reply/${replyId}`);
    return response.data;
};
